// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"8":"22cfa70d","413":"154c93b3","429":"52d30820","453":"d855a71b"}[chunkId] + ".chunk.js";
};